import type { SendEventParams } from '@/utils/sendEvent';
import { GomarkePixelConfig, PixelResponse } from '../../types';
import { BaseTracker } from './BaseTracker';
import { getCoreVisitorId } from '@/core';

/**
 * Tracker para eventos de visualização de página
 */
export class PageViewTracker extends BaseTracker {
  /**
   * Retorna o payload para envio centralizado no ConversionEngine.
   */
  public getPayload(): SendEventParams {
    return {
      category: 'ENGAGEMENT',
      type: 'PAGE_VIEW',
      eventData: {
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_title: typeof document !== 'undefined' ? document.title : '',
        referrer: typeof document !== 'undefined' ? document.referrer : '',
        hostname: typeof window !== 'undefined' ? window.location.hostname : '',
        path: typeof window !== 'undefined' ? window.location.pathname : '',
      },
      config: this.config,
      sessionId: this.sessionId,
      version: this.version,
      visitorId: this.visitorId,
    };
  }

  /**
   * Rastreia uma visualização de página
   */
  public async track(): Promise<PixelResponse> {
    return this.sendEvent(this.getPayload());
  }

  /**
   * Rastreia uma visualização de página com parâmetros customizados
   */
  public async trackWithParams(
    customParams: Record<string, unknown>
  ): Promise<PixelResponse> {
    return this.sendEvent({
      category: 'ENGAGEMENT',
      type: 'PAGE_VIEW',
      eventData: {
        page_url: window.location.href,
        page_title: document.title,
        referrer: document.referrer,
        hostname: window.location.hostname,
        path: window.location.pathname,
        ...customParams,
      },
      config: this.config,
      sessionId: this.sessionId,
      version: this.version,
      visitorId: this.visitorId,
    });
  }
}

// Função de conveniência para compatibilidade com código existente
export const pageView = async (
  config: GomarkePixelConfig,
  sessionId: string,
  version: string
): Promise<PixelResponse> => {
  const visitorId = getCoreVisitorId();
  if (!visitorId) {
    throw new Error('Visitor ID não encontrado');
  }
  const tracker = new PageViewTracker(config, sessionId, visitorId, version);
  return tracker.track();
};
